module.exports = {
  LogoImg: require('../assets/img/jp/AI-keyword-white.png'),
  defaultLang: 'jp',
  KwhStripeLogoImg: require('../assets/img/jp/index-img.png'),
  Slide1: require('../assets/img/jp/Slide1.png'),
  Slide2: require('../assets/img/jp/Slide2.png'),
  Slide3: require('../assets/img/jp/Slide3.png'),
  Slide4: require('../assets/img/jp/Slide4.png'),
  Slide5: require('../assets/img/jp/Slide5.png'),
  Slide6: require('../assets/img/jp/Slide6.png'),
  Slide7: require('../assets/img/jp/Slide7.png'),
  Slide8: require('../assets/img/jp/Slide8.png'),
  Slide9: require('../assets/img/jp/Slide9.png'),
  Slide10: require('../assets/img/jp/Slide10.png'),
  plansData: {
    free: { title: 'LITTLE HERO', features: [''] },
    big: { title: 'BIG HERO', features: ['transaction_track'] },
    giant: { title: 'GIANT HERO', features: ['transaction_track'] },
    ultimate: { title: 'ULTIMATE HERO', features: ['transaction_track'] }
  }
};



// WEBPACK FOOTER //
// ./src/brand-configs/jp.js